/* Floretti 3.0 — "Lees volledig" op reviewkaarten.
   De knop verbergt zichzelf als de tekst toch al helemaal past, zodat je geen
   knop krijgt die niets doet. */
(function () {
  'use strict';

  class FlorettiReviews extends HTMLElement {
    connectedCallback() {
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-review-card]'));
      this.cards.forEach(this.setupCard.bind(this));

      this._onResize = this.debounce(this.syncAllToggles.bind(this), 150);
      window.addEventListener('resize', this._onResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
    }

    setupCard(card) {
      var toggle = card.querySelector('[data-review-toggle]');
      var quote = card.querySelector('blockquote');
      if (!toggle || !quote) return;

      this.syncToggle(card);

      toggle.addEventListener('click', function () {
        var expanded = card.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
      });
    }

    syncToggle(card) {
      var toggle = card.querySelector('[data-review-toggle]');
      var quote = card.querySelector('blockquote');
      if (!toggle || !quote) return;
      if (card.classList.contains('is-expanded')) return;

      // Past de tekst binnen de 3 regels? Dan is de knop overbodig.
      var overflows = quote.scrollHeight > quote.clientHeight + 1;
      toggle.hidden = !overflows;
    }

    syncAllToggles() {
      this.cards.forEach(this.syncToggle.bind(this));
    }

    debounce(fn, wait) {
      var timer;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(fn, wait);
      };
    }
  }

  if (!customElements.get('floretti-reviews')) {
    customElements.define('floretti-reviews', FlorettiReviews);
  }
})();
